export type ImageComplaintReason = "quantity" | "different_product" | "appearance" | "outdated" | "custom";

export const IMAGE_COMPLAINT_REASONS = [
  { value: "quantity", labelGerman: "Falsche Verkaufseinheit / Menge" },
  { value: "different_product", labelGerman: "Anderer Artikel" },
  { value: "appearance", labelGerman: "Bildqualität / Optik" },
  { value: "outdated", labelGerman: "Veraltete Abbildung" },
  { value: "custom", labelGerman: "Eigene Begründung" },
] as const satisfies ReadonlyArray<{ value: ImageComplaintReason; labelGerman: string }>;

/** Editable requests; product dimensions, pack sizes and policy violations cannot be inferred. */
export function buildImageComplaintStartReason(reason: ImageComplaintReason): string {
  switch (reason) {
    case "quantity":
      return "Bitte prüfen Sie, ob die dargestellte Menge und Verkaufseinheit zum angebotenen Lieferumfang passen. Falls dies nicht zutrifft, entfernen Sie das Bild bitte oder ersetzen Sie es durch eine Abbildung der tatsächlich angebotenen Einheit.";
    case "different_product":
      return "Bitte prüfen Sie, ob dieses Bild den angebotenen Artikel in der richtigen Variante zeigt. Falls ein anderer Artikel oder eine abweichende Variante dargestellt ist, entfernen Sie das Bild bitte oder ersetzen Sie es durch eine passende Produktabbildung.";
    case "appearance":
      return "Bitte prüfen Sie die Produktabbildung und aktualisieren Sie sie gegebenenfalls. Bitte verwenden Sie eine klare, professionelle und hochauflösende Darstellung, auf der der angebotene Artikel und seine Details gut erkennbar sind.";
    case "outdated":
      return "Bitte prüfen Sie, ob dieses Bild die aktuelle Ausführung und Verpackung des angebotenen Produkts zeigt. Falls die Abbildung veraltet ist, entfernen Sie sie bitte oder ersetzen Sie sie durch eine aktuelle passende Produktabbildung.";
    case "custom":
      return "Bitte prüfen Sie, ob dieses Produktbild zum angebotenen Artikel passt. Entfernen oder ersetzen Sie es bitte durch eine passende Produktabbildung, sofern sich eine Abweichung bestätigt.";
  }
}

export function buildImageComplaintReason(reason: ImageComplaintReason, { asin, sellerSku, existingReason }: {
  asin: string;
  sellerSku: string;
  existingReason?: string;
}): string {
  const existing = existingReason?.trim();
  const identity = `ASIN: ${asin}\nSKU: ${sellerSku}`;
  if (reason === "custom" && existing) return `${identity}\n${existing}`;
  const suggestion = buildImageComplaintStartReason(reason);
  return `${identity}\n${suggestion}${existing ? `\nBereits erfasster Grund: ${existing}` : ""}`;
}
